import { HttpErrorResponse, HttpHandler, type HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { CURRENT_CLIENT_TEMPLATE_VAR, NavigationService } from '@core';
import { environment } from '@env/environment';
import { Store } from '@ngrx/store';
import { AuthActions, AuthSelectors } from '@ngrx-store';
import { take, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class AppInterceptor implements HttpInterceptor {
  private store = inject(Store);
  private navigationService = inject(NavigationService);

  intercept(request: HttpRequest<unknown>, next: HttpHandler) {
    const user = localStorage.getItem('user');
    const accessToken = user && JSON.parse(user)['accessToken'];
    const assetRequest = request.url.includes('/assets/');
    const clientId = this.navigationService.getCurrentClientId();
    const envApiPathSuffix = request.url.startsWith('/') ? '' : '/';

    const url = (environment.api + envApiPathSuffix + request.url).replace(CURRENT_CLIENT_TEMPLATE_VAR, clientId);

    let clonedRequest = request.clone({ url });

    if (!assetRequest) {
      let headers = accessToken ? request.headers.set('Authorization', `Bearer ${accessToken}`) : request.headers;

      headers = headers.set('x-timezone', Intl.DateTimeFormat().resolvedOptions().timeZone);

      clonedRequest = clonedRequest.clone({ headers });
    }

    return next.handle(clonedRequest).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          this.store
            .select(AuthSelectors.isLoggedIn)
            .pipe(take(1))
            .subscribe(isLoggedIn => {
              if (isLoggedIn) {
                this.store.dispatch(AuthActions.logout());
              }
            });
        }

        return throwError({
          message: error.error?.message || error.message,
          name: 'Error',
          status: error.status,
        });
      }),
    );
  }
}
